import * as React from 'react'
import Head from 'next/head'
import Layout from '../components/Layout'
import image from '../../public/img/nubrakes-brake-repair-header.jpg'
import { BgImage } from '../components/BgImage'

const ContactSuccessPage: React.FC<{ image: any }> = () => {
  return (
    <Layout title={`Request Received - NuBrakes Mobile Brake Repair`}>
      <Head>
        <meta name="robots" content="noindex,nofollow" />
      </Head>
      <section className="py-0">
        <BgImage src={image.src}>
          <div className={'text-center'}>
            <h1 className="title text-white">{'Thank you for contacting us.'}</h1>
            <p className={`description text-white`}>
              {'A NuBrakes representative will reach out to you shortly to address your inquiry.'}
            </p>
          </div>
        </BgImage>
      </section>
    </Layout>
  )
}

export default ContactSuccessPage
